<template>
    <div>
      <div v-if="affiliateCompany">
        <div class="row m-b-lg m-t-lg wrapper">
          <div class="col-md-12">
            <h3>
              {{ affiliateCompany.name }}
            </h3>
            <div class="row">
              <div class="col-md-4">
                <table class="table small m-b-xs">
                  <tbody>
                  <tr>
                    <td>Affiliate Company Name</td>
                    <td>
                      <e-txt
                        type="editable"
                        :text="affiliateCompany.name"
                        @input="updateCompany($event, 'name')"
                        close-on-save="true"
                      ></e-txt>
                    </td>
                  </tr>
                  <tr>
                    <td>URL</td>
                    <td>
                        <e-txt
                        type="editable"
                        :text="affiliateCompany.url"
                        @input="updateCompany($event, 'url')"
                        close-on-save="true"
                      ></e-txt>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-4">
                <table class="table small m-b-xs">
                  <tbody>
                  <tr>
                    <td>Username</td>
                    <td>
                      <e-txt
                        type="editable"
                        :text="affiliateCompany.username"
                        @input="updateCompany($event, 'username')"
                        close-on-save="true"
                      ></e-txt>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Password
                    </td>
                    <td>
                      <e-txt
                        type="editable"
                        :text="affiliateCompany.password"
                        @input="updateCompany($event, 'password')"
                        close-on-save="true"
                      ></e-txt>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { AFFILIATE_COMPANY_SET } from '../../../../store/mutation-types'

export default {
  computed: {
    ...mapGetters({
      affiliateCompany: 'getAffiliateCompany'
    })
  },
  components: {
    eTxt: EditText
  },
  mounted () {
    document.title = 'Affiliate Company :: PBN360 by Aphex Media'
    console.log(this.affiliateCompany)
  },
  methods: {
    async updateCompany (val, prop) {
      let data = {}
      data[prop] = val
      try {
        let resp = await axios.patch(`/advertisers/affiliate-companies/${this.affiliateCompany.id}`, data)
        this.$toastr.success(`${prop} updated successfully`, 'Good')
        this.$store.commit(AFFILIATE_COMPANY_SET, resp.data.affiliateCompany)
      } catch (error) {
        this.$toastr.error(error, 'Unable to update')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/AffiliateCompany/Header.vue